import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04e6892e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "button",
  type: "button"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "subtopic" }

import { Tab } from '@/types/enums';

export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarBtn',
  props: {
    id: null,
    topic: null,
    subtopic: null,
    img: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    (__props.id !== _unref(Tab).Home)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("img", {
            class: "icon",
            src: __props.img,
            alt: ""
          }, null, 8, _hoisted_2),
          _createTextVNode(" " + _toDisplayString(__props.topic) + " ", 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.subtopic), 1)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})